<template>
  <div class="register-res">
    <div class="btn">
      <div @click="bindDownload">下载 betterWE星球APP</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    bindDownload() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    }
  }
}
</script>
<style lang="scss" scoped>
.register-res {
  width: 100%;
  height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d39efbc82fdf76ad692d63ebdb8ec0af.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .btn {
    position: absolute;
    text-align: center;
    width: 283px;
    height: 44px;
    line-height: 44px;
    background: #1f2021;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.12);
    left: 50%;
    bottom: 12vh;
    transform: translate(-50%, 0%);
  }
  .tips {
    position: absolute;
    width: 241px;
    padding: 10px 9px;
    box-sizing: border-box;
    background: #6e44ff;
    border-radius: 10px;
    box-shadow: 0px 4px 6px 0px rgba(49, 6, 201, 0.3);
  }
  .tip-circle {
    position: absolute;
    left: 50%;
    top: -16px;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 0;
    height: 0;
    box-sizing: border-box;
  }
  .tip-content {
    position: absolute;
    width: 241px;
    background: #6e44ff;
    border-radius: 20px;
    padding: 10px 14px;
    padding-left: 51px;
    left: 50%;
    transform: translate(-50%, 0%);
    box-sizing: border-box;
    box-shadow: 0px 4px 6px 0px rgba(49, 6, 201, 0.3);
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
    .tip-text {
      display: inline-block;
      text-align: left;
    }
    .tip-image {
      width: 80px;
      height: 75px;
      position: absolute;
      left: -30px;
      bottom: 0px;
      object-fit: contain;
    }
  }
  .content-top {
    bottom: 8px;
  }
  .circle-bottom {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid rgba(110, 68, 255, 1);
  }
}
</style>
